import CheckIcon from '@mui/icons-material/Check';
import CrossIcon from '@mui/icons-material/Clear';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

const successStyles = {
	backgroundColor: '#c2ffe4'
};

const errorStyles = {
	backgroundColor: '#ffc2c2'
};

const VerificationResultForm = ({ result = {} }) => {
	return (
		<Box minWidth="70%">
			<Typography>Created: {dayjs().format('MM/DD/YY h:m a')}</Typography>
			<Typography display="flex">
				Domain Valid:
				{result.sg_domain_valid ? (
					<CheckIcon
						color="success"
						sx={{
							marginLeft: '5px'
						}}
					/>
				) : (
					<>
						<CrossIcon
							color="error"
							sx={{
								marginLeft: '5px'
							}}
						/>
						<Typography
							component="span"
							sx={{
								marginLeft: '20px',
								alignSelf: 'flex-end',
								color: '#777777'
							}}
						>
							Please allow 24 hours for automatic validation
						</Typography>
					</>
				)}
			</Typography>
			<Typography>Record Type: CNAME</Typography>
			<Grid container spacing={2} marginTop="10px" marginBottom="24px">
				<Grid item xs={6}>
					<FormControl fullWidth>
						<TextField
							value={result.sg_mail_cname_host}
							variant="filled"
							fullWidth
							label="Mail Host"
							InputProps={{
								readOnly: true
							}}
							sx={result.sg_mail_cname_valid ? successStyles : errorStyles}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<FormControl fullWidth>
						<TextField
							value={result.sg_mail_cname_data}
							variant="filled"
							fullWidth
							label="Mail Record Data"
							InputProps={{
								readOnly: true
							}}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<FormControl fullWidth>
						<TextField
							value={result.sg_dkim1_host}
							variant="filled"
							fullWidth
							label="DKIM1 Host"
							InputProps={{
								readOnly: true
							}}
							sx={result.sg_dkim1_valid ? successStyles : errorStyles}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<FormControl fullWidth>
						<TextField
							value={result.sg_dkim1_data}
							variant="filled"
							fullWidth
							label="DKIM1 Data"
							InputProps={{
								readOnly: true
							}}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<FormControl fullWidth>
						<TextField
							value={result.sg_dkim2_host}
							variant="filled"
							fullWidth
							label="DKIM2 Host"
							InputProps={{
								readOnly: true
							}}
							sx={result.sg_dkim2_valid ? successStyles : errorStyles}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<FormControl fullWidth>
						<TextField
							value={result.sg_dkim2_data}
							variant="filled"
							fullWidth
							label="DKIM2 Data"
							InputProps={{
								readOnly: true
							}}
						/>
					</FormControl>
				</Grid>
			</Grid>
			<Alert severity="info" sx={{ alignItems: 'center' }}>
				<Typography sx={{ fontSize: '14px' }}>
					Add the following CNAME records to your DNS Host Provider.
				</Typography>
				<Typography sx={{ fontSize: '14px' }}>
					Please use the "Contact Us" form on our homepage if you have any issues
				</Typography>
			</Alert>
		</Box>
	);
};

export default VerificationResultForm;
